import * as React from 'react';

import Loadable from 'react-loadable';

import { Route, RouteProps } from 'react-router-dom';

import './AsyncRoute.scss';

interface AsyncRouteProps extends RouteProps {
  loader: () => Promise<any>;
  name: string;
}

export class AsyncRoute extends React.Component<AsyncRouteProps, {}> {
  private componentLoadable: React.ComponentType<AsyncRouteProps>;

  constructor(props: AsyncRouteProps) {
    super(props);

    this.componentLoadable = Loadable({
      loader: props.loader,
      loading: () => null,
      render(loadedLoadable, propsLoadable) {
        const Component = loadedLoadable[props.name];
        return <Component {...propsLoadable}/>;
      }
    });
  }

  render() {
    const { loader, name, ...rest } = this.props;
    return <Route {...rest} component={this.componentLoadable}/>;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AsyncRoute/AsyncRoute.tsx